/* eslint-disable compat/compat */

function rectChanged(prevRect, nextRect) {
  if (!prevRect) {
    return !!nextRect;
  }
  if (!nextRect) {
    return true;
  }
  return Object.keys(prevRect).some(field => nextRect[field] !== prevRect[field]);
}
export function onRectChange(getRect, onChange) {
  let prevRect = getRect();
  const handler = () => {
    const nextRect = getRect();
    if (rectChanged(prevRect, nextRect)) {
      prevRect = nextRect;
      onChange(nextRect);
    }
  };
  const mutationObserver = new MutationObserver(handler);
  mutationObserver.observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    characterData: true
  });
  document.body.addEventListener('transitionend', handler);
  document.body.addEventListener('animationend', handler);
  window.addEventListener('resize', handler);
  onChange(prevRect);
  return () => {
    mutationObserver.disconnect();
    document.body.removeEventListener('transitionend', handler);
    document.body.removeEventListener('animationend', handler);
    window.removeEventListener('resize', handler);
  };
}
/* eslint-enable compat/compat */